import { Component } from "@angular/core";
import { SimpleUntranslatedTableColumn } from '../custom-table-column/simple-untranslated-table-column';
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'simple-untranslated-table-value',
    template: '<span [ngClass]="getClass()">{{ getValue() }}</span>'
})
export class SimpleUntranslatedTableValueComponent extends CustomTableValueComponent<SimpleUntranslatedTableColumn> {
}